import classNames from 'classnames'
import ContactUsButton from './contact_us_button'
import LogoutButton from './logout_button'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './styles'
import SunsetHeader from './sunset_header'
import SunsetLogin from './sunset_login'
import SunsetMain from './sunset_main'

const SunsetDisplay = ({ isLoggedIn }) => {
  return (
    <div className={classNames('darkMode', styles.page)}>
      {/* <ModuleLoader> */}
      <LogoutButton />
      <SunsetHeader />
      {isLoggedIn ? <SunsetMain /> : <SunsetLogin />}
      <ContactUsButton />
      {/* </ModuleLoader> */}
    </div>
  )
}

SunsetDisplay.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
}

export { SunsetDisplay }
